export default __webpack_public_path__ + "static/media/in.a15842a6.svg";